import { reducerFactory } from 'common/store/scope';

import { searchu } from 'common/store/search/advanced/reducer';
import {
  resource,
  composeReducers,
} from 'common/store/reducer';

import {
  NAMESPACE,
} from './actions';

export default composeReducers(
  resource.factory(NAMESPACE),
);